import React from 'react'
import { Button } from '../ButtonElement'

import Icon1 from "../../img/icon/svg-pin.svg";
import Icon2 from "../../img/icon/svg-phone.svg";
import Icon4 from "../../img/icon/svg-whatsapp.svg";
import Icon5 from "../../img/icon/svg-linkedin.svg";

import MyMap from "./MyMap";

import {
    ContactContainer,
    ContactsTextWrapper,
    ContactWrapper,
    ContactRow,

    ContactsCard,
    ContactsH1,
    ContactsH2,
    ContactsIcon,
    ContactsP,
    ContactInfoContainer,
    ContactInput,
    ContactElement,
    ContactText,
    ContactsIconContainer
} from './ContactElements'


const ContactSection = () => {
    return (
        <>
            <ContactContainer id='contact'>
                <ContactsTextWrapper>
                    <ContactsH1 transparent>Get in touch</ContactsH1>
                    <ContactsH1>We want to support you</ContactsH1>
                    <ContactsH1>contact us</ContactsH1>
                    <ContactsH1>we are ready!</ContactsH1>
                </ContactsTextWrapper>
                <ContactWrapper>
                    <ContactRow>
                        <ContactInfoContainer>
                            <ContactRow>
                                <ContactsH1>Tijuana</ContactsH1>
                            </ContactRow>
                            <ContactElement>
                                <ContactsIconContainer>
                                    <ContactsIcon src={Icon1} width='60px'/>
                                </ContactsIconContainer>
                                <ContactText>
                                    Privada Santa Elena #10089-5 Col. La Gloria.
                                </ContactText>
                            </ContactElement>
                            <ContactElement>
                            <ContactsIconContainer>
                                <ContactsIcon src={Icon2} width='45px'/>
                            </ContactsIconContainer>
                                <ContactText>
                                    (664) 882 5557 <br></br> (664) 882 5403
                                </ContactText>
                            </ContactElement>
                            <ContactElement 
                            href="https://mx.linkedin.com/in/mp-soluciones-a4706b19b"
                            target="_blank"
                            rel="noopener noreferrer">
                            <ContactsIconContainer>
                                <ContactsIcon src={Icon5} width='50px'/>
                            </ContactsIconContainer>
                                <ContactText>
                                    Linkedin
                                </ContactText>
                            </ContactElement>
                            <ContactRow>
                            <ContactsH1>Irapuato</ContactsH1>
                            </ContactRow>
                            <ContactElement>
                                <ContactsIconContainer>
                                    <ContactsIcon src={Icon1} width='60px'/>
                                </ContactsIconContainer>
                                <ContactText>
                                    Rio Tonala 1679, Col La Pradera, Irapuato Guanajuato. 
                                </ContactText>
                            </ContactElement>
                            <ContactElement>
                            <ContactsIconContainer>
                                <ContactsIcon src={Icon2} width='45px'/>
                            </ContactsIconContainer>
                                <ContactText>
                                Cel 462 289 8836 <br></br> 462 115 9283
                                </ContactText>
                            </ContactElement>
                        </ContactInfoContainer>
                        <MyMap/>
                    </ContactRow>

                </ContactWrapper>
            </ContactContainer>
        </>
    )
}

export default ContactSection
